<template>
  <service-area-table :items="getMyList(username)" :loading="loading"></service-area-table>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import ServiceAreaTable from "./ServiceAreaTable";

export default {
  components: {
    ServiceAreaTable,
  },
  computed: {
    ...mapGetters({
      getMyList: "dashboard/serviceArea/getMyList",
    }),
    ...mapState({
      username: state => state.session.username,
      loading: state => state.dashboard.serviceArea.loading,
    }),
  },
};
</script>
